<template>
  <div class="hello">
    <div
      style="padding: 10px;background: #185F9B;text-align: left;font-size:1.1rem;height:2rem;"
    >
      <img
        src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
        style="width:30px"
      />
      <label style="position: absolute;left: 50px;font-weight: 700;color: #fff;"
        >跑兔体育</label
      >
      <label
        v-if="isShow === '1'"
        @click="nacToZy"
        style="position: absolute;right: 13px;font-weight: 700;color: #fff;"
      >
        主页
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: String,
      default: ""
    }
  },
  methods: {
    nacToZy() {
      var routeValue = localStorage.getItem("routeValue");
      if (
        routeValue === null ||
        routeValue === undefined ||
        routeValue.length === 0
      ) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: "/" + routeValue });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/commonCom/HeaderCom.vue